'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\n  -webkit-appearance: none;\n  appearance: none;\n  border: none;\n  height: 10px;\n  width: 100%;\n\n  ::-webkit-progress-bar {\n    background: ', ';\n    border-radius: 20px;\n  }\n\n  ::-webkit-progress-value {\n    background: ', ';\n    border-radius: 20px;\n  }\n'], ['\n\n  -webkit-appearance: none;\n  appearance: none;\n  border: none;\n  height: 10px;\n  width: 100%;\n\n  ::-webkit-progress-bar {\n    background: ', ';\n    border-radius: 20px;\n  }\n\n  ::-webkit-progress-value {\n    background: ', ';\n    border-radius: 20px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n'], ['\n  color: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _metrixCommon = require('metrix-common');

var _Container = require('../Container');

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TimeIcon = function TimeIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement(
                'style',
                null,
                '.a',
                '{',
                'fill:rgba(255,255,255,0)',
                '}'
            )
        ),
        _react2.default.createElement('path', {
            className: 'a',
            d: 'M0 0h24v24H0z'
        }),
        _react2.default.createElement('path', {
            d: 'M12 22a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-18a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8zm3.625 12.654a.508.508 0 0 1-.355-.144l-4-4a.533.533 0 0 1-.15-.35V6.5a.5.5 0 0 1 .5-.5h.76a.5.5 0 0 1 .5.5v5.14l3.63 3.63a.507.507 0 0 1 0 .71l-.53.53a.506.506 0 0 1-.355.144z'
        })
    );
};

TimeIcon.defaultProps = {
    xmlns: 'http://www.w3.org/2000/svg',
    width: '24',
    height: '24',
    viewBox: '0 0 24 24'
};


var Progress = _styledComponents2.default.progress(_templateObject, (0, _metrixCommon.getColor)(_metrixCommon.Colors.Secondary, _metrixCommon.Opacity.Light), _metrixCommon.Colors.Secondary);

var ProgressHeader = (0, _styledComponents2.default)(_metrixCommon.Header)(_templateObject2, _metrixCommon.Colors.Secondary);

var Step = function (_React$Component) {
    _inherits(Step, _React$Component);

    function Step() {
        _classCallCheck(this, Step);

        return _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).apply(this, arguments));
    }

    _createClass(Step, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var isProgressBarHidden = this.props.context && this.props.context.storefront && this.props.context.storefront.progressBarHidden;
            var progress = this.props.control && this.props.control.completionPercentage && this.props.control.completionPercentage || 0;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                !isProgressBarHidden && _react2.default.createElement(
                    _metrixCommon.Splash,
                    { color: (0, _metrixCommon.getColor)(_metrixCommon.Colors.Secondary, _metrixCommon.Opacity.VeryLight) },
                    _react2.default.createElement(
                        _metrixCommon.Container,
                        { top: _metrixCommon.Sizes.xxs,
                            bottom: _metrixCommon.Sizes.xxs
                        },
                        _react2.default.createElement(
                            _metrixCommon.Grid,
                            null,
                            _react2.default.createElement(
                                _metrixCommon.Row,
                                null,
                                _react2.default.createElement(
                                    _metrixCommon.Column,
                                    { xs: 1,
                                        md: 2,
                                        lg: 2
                                    },
                                    _react2.default.createElement(
                                        _metrixCommon.Container,
                                        { fullSize: true,
                                            verticalAlignment: _metrixCommon.Alignments.center,
                                            horizontalAlignment: _metrixCommon.Alignments.right
                                        },
                                        _react2.default.createElement(TimeIcon, { fill: _metrixCommon.Colors.Secondary })
                                    )
                                ),
                                _react2.default.createElement(
                                    _metrixCommon.Column,
                                    { xs: 9,
                                        md: 8,
                                        lg: 8
                                    },
                                    _react2.default.createElement(
                                        _metrixCommon.Container,
                                        { fullSize: true,
                                            verticalAlignment: _metrixCommon.Alignments.center
                                        },
                                        _react2.default.createElement(Progress, { value: progress,
                                            max: 100
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    _metrixCommon.Column,
                                    { xs: 2,
                                        md: 2,
                                        lg: 2
                                    },
                                    _react2.default.createElement(ProgressHeader, { size: _metrixCommon.Sizes.xs,
                                        textAlign: _metrixCommon.Alignments.left,
                                        left: _metrixCommon.Sizes.xss,
                                        fullSize: false,
                                        text: progress + ' %'
                                    })
                                )
                            )
                        )
                    )
                ),
                this.props.step && this.props.step.containers && this.props.step.containers.length > 0 && this.props.step.containers.map(function (container, i) {
                    return _react2.default.createElement(_Container2.default, { key: 'container_' + i,
                        context: _this2.props.context,
                        configuration: _this2.props.context.configuration,
                        session: _this2.props.context.session,
                        culture: _this2.props.context.session.culture,
                        valid: _this2.props.valid,
                        container: container,
                        returns: _this2.props.returns,
                        doSetReturn: _this2.props.doSetReturn,
                        doReduceDynamicDate: _this2.props.doReduceDynamicDate,
                        doStep: _this2.props.doStep,
                        doExecuteAction: _this2.props.doExecuteAction,
                        reference: _this2.props.reference,
                        entity: _this2.props.entity,
                        analytics: _this2.props.analytics,
                        stepAnalytics: _this2.props.stepAnalytics,
                        workflowConfiguration: _this2.props.workflowConfiguration
                    });
                })
            );
        }
    }]);

    return Step;
}(_react2.default.Component);

exports.default = Step;